const EXPECTED_ERROR_ENDPOINTS = {
    403: [/users\/\d+\/score/, /v3\/objectives\/\d+/],
    404: [/culture\/password\/verify_registration/]
};
// handleSentry (client/helperClient.tsx) fingerprints an API error as
// [method, status as a string, message] and tags its endpoint. Change that
// shape -> change this read.
export const isExpectedApiError = (event) => {
    const status = Number(event?.fingerprint?.[1]);
    const endpoint = event?.tags?.endpoint;
    if (typeof endpoint !== 'string')
        return false;
    return (EXPECTED_ERROR_ENDPOINTS[status] || []).some((matcher) => matcher.test(endpoint));
};
